<ng-template #errorTpl>
  <em-error-result
    status="error"
    title="An error occurred"
    [subTitle]="errorMsg ?? ''"
  ></em-error-result>
</ng-template>

<nz-card [nzTitle]="titleTpl">
  <nz-skeleton [nzActive]="true" [nzLoading]="(isLoading$ | async) ?? false">
    <ng-container *ngIf="isBomCreated$ | async; else noData">
      <button
        class="add-button"
        nz-button
        nzType="primary"
        routerLink="."
        [queryParams]="routeParam.add"
        queryParamsHandling="merge"
        [nzGhost]="true"
        nz-tooltip
        nzTooltipTitle="Add new material"
      >
        <span nz-icon nzType="plus"></span>
        Add material
      </button>

      <nz-table
        *emAlias="table.page$ | async as page"
        #bomTable
        [nzData]="page?.data || []"
        [nzLoading]="table.loading$ | async"
        [nzFrontPagination]="false"
        [nzPageSizeOptions]="[5, 10, 20, 30]"
        [nzPageSize]="table.perPage"
        [nzPageIndex]="table.pageIndex"
        (nzQueryParams)="table.onTableChange($event)"
        nzShowSizeChanger
        [nzTotal]="page?.total || 0"
        [nzNoResult]="errorMsg ? errorTpl : ''"
      >
        <thead>
          <tr>
            <th>Material number</th>
            <th>Material</th>
            <th>Weight (1000 pieces)</th>
            <th>Sort String</th>
            <th></th>
          </tr>
        </thead>
        <tbody *emAlias="uiState$ | async as uiState">
          <tr *ngFor="let item of bomTable.data; trackBy: trackByRef">
            <td>
              {{ item.component }}
            </td>
            <td>
              {{ item.componentDescription }}
            </td>
            <td>{{ item.weight }} {{ item.unit | lowercase }}</td>
            <td>
              {{ item.sortString }}
            </td>
            <td class="action-column">
              <button
                nz-button
                nzType="primary"
                [nzGhost]="true"
                routerLink="."
                [queryParams]="editQueryParamsMap[item.id]"
                queryParamsHandling="merge"
                nz-tooltip
                nzTooltipTitle="Edit material"
              >
                <i nz-icon nzType="edit" nzTheme="fill"></i>
              </button>

              <ng-container *emAlias="(isBomLocked$ | async) ?? false as isBomLocked">
                <button
                  nz-button
                  nzDanger
                  nz-popconfirm
                  [nzPopconfirmTitle]="confirmDelete"
                  (nzOnConfirm)="deleteHandlersMap[item.id]()"
                  [nzLoading]="bomItemLoadingMap[item.id]"
                  nz-tooltip
                  nzTooltipTitle="Delete material"
                >
                  <i nz-icon nzType="delete" nzTheme="fill"></i>
                </button>

                <ng-template #confirmDelete>
                  <div>Are you sure?</div>

                  <input
                    *ngIf="isBomLocked"
                    class="eco-input"
                    nz-input
                    placeholder="ECO number"
                    [formControl]="ecoNumberControl"
                  />
                </ng-template>

                <ng-container *ngIf="uiState?.[item.id]?.error as uiError">
                  <button
                    nz-button
                    nzDanger
                    (click)="showError(generateEcoErrorMessage(uiError, isBomLocked))"
                    nz-tooltip
                    nzTooltipTitle="An error occurred, click to show error"
                  >
                    <i nz-icon nzType="warning" nzTheme="fill"></i>
                  </button>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </ng-container>
  </nz-skeleton>
</nz-card>

<ng-template #titleTpl>
  <div nz-row nzJustify="space-between">
    <span nz-col>Material BOM</span>

    <ng-container *ngIf="isLoading$ | async; else headerContent">
      <nz-skeleton-element
        nz-col
        nzType="input"
        [nzActive]="true"
        style="width: 200px"
      ></nz-skeleton-element>
      <nz-skeleton-element
        nz-col
        nzType="input"
        [nzActive]="true"
        style="width: 120px"
      ></nz-skeleton-element>
    </ng-container>

    <ng-template #headerContent>
      <ng-container *ngIf="materialBOMHeader$ | async as materialBOMHeader">
        <div nz-col *ngIf="isBomCreated$ | async">
          <div nz-row [nzGutter]="40">
            <div nz-col>Type: {{ bomType$ | async }}</div>
            <div nz-col>Status: {{ materialBOMHeader?.bomStatus }}</div>
          </div>
        </div>
        <button
          *ngIf="isBomCreated$ | async"
          nz-col
          [disabled]="isBomLocked$ | async"
          nz-button
          nzType="primary"
          nz-popconfirm
          nzPopconfirmTitle="Are you sure you want to lock the BOM (Status: 22)?"
          (nzOnConfirm)="lockBOM()"
        >
          <i nz-icon nzType="lock"></i>
          {{ (isBomLocked$ | async) ? 'BOM is locked' : 'Lock BOM' }}
        </button>
      </ng-container>
    </ng-template>
  </div>
</ng-template>

<ng-template #noData>
  <div class="center-align">
    <div><h3>No material BOM created</h3></div>
    <div><button nz-button nzType="primary" (click)="createMaterialBom()">Create</button></div>
  </div>
</ng-template>
